import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserSessionPersistence } from 'firebase/auth';

// IMPORTANTE (sicurezza): in produzione questa CONFIG deve venire da una
// Firebase web app DEDICATA per l'admin (stesso project Firebase ma una
// nuova "app registration" sulla console). Questo permette di:
//   - tracciare auth admin separato da auth utente
//   - configurare CSP/CORS specifici
//   - revocare la sola app admin in caso di compromise senza impattare gli utenti
// In dev puoi riusare la stessa config dell'app tools (stesse env var).
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// SESSION persistence: la sessione admin scade quando l'utente chiude
// il browser. Diverso dall'app tools che usa LOCAL (persistente).
// Riduce la window di session-replay se il device viene compromesso.
setPersistence(auth, browserSessionPersistence).catch(err => {
    // eslint-disable-next-line no-console
    console.error('[admin auth] setPersistence failed', err);
});

export const googleProvider = new GoogleAuthProvider();
// Force account picker su Google sign-in: evita il "auto-sign-in"
// con l'ultimo account, che è desiderabile su user app ma rischioso
// per admin (preferiamo sempre conferma esplicita).
googleProvider.setCustomParameters({ prompt: 'select_account' });
